import React from "react";
import Toggle from "../Toggle/Toggle";
import "./Navbar.css";
import { Link } from "react-scroll";
const navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left">
      <div className="Logo">
                <img src="./aiecWebTabLogo.jpeg"alt='logo'/>
            </div>
        <div className="n-name">AL-ISKAN Engineering Consultancy</div>
        {/*<Toggle />*/}
      </div>
      {/* right */}
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <li>
              <Link activeClass="active" to="Navbar" spy={true} smooth={true}>
                About
              </Link>
            </li>
            <li>
              <Link to="services" spy={true} smooth={true}>
                Services
              </Link>
            </li>
            <li>
              <Link to="works" spy={true} smooth={true}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="testimonial" spy={true} smooth={true}>
                Testimonials
              </Link>
            </li>
            
          </ul>
        </div>
        {/*<Link to="contact" spy={true} smooth={true}>*/}

        <a href="https://wa.me/96899803955/?text=Dear AL-ISKAN team, I would like to opt for one of your services. Please call me back on this number.">
          
        <button className="button n-button">Contact</button>
        </a>
        {/*</Link>*/}
      </div>
    </div>
  );
};

export default navbar;
